/**
 * @fullvsl/app-shell/views/support — help & support surface (FUL-272).
 *
 * Self-serve resources for the FullVSL operational suite: key concepts, the
 * standard VSL workflow, common iframe/autoplay pitfalls, and where each
 * capability lives in the app. Keeps the "Suporte" menu item functional instead
 * of a dead-end.
 */
import { el, append, icon, ICONS } from "../dom";

export function renderSupportView(): HTMLElement {
  const wrapper = el("div");

  // ---- Page header ----
  const header = el("div", "fva-page-header");
  const headerText = el("div");
  append(headerText, el("h2", null, "Suporte"));
  append(headerText, el("p", null, "Guias, conceitos e respostas sobre a suíte FullVSL."));
  append(header, headerText);
  append(wrapper, header);

  const grid = el("div", "fva-tpl-grid");

  grid.appendChild(
    guideCard(
      "Primeiros passos",
      [
        "Crie uma VSL pela barra lateral ou pelo botão Nova VSL.",
        "Cole uma URL direta de MP4 ou selecione uma mídia do Full Funnel.",
        "Visualize o player e edite os overlays em tempo real.",
        "Publique para obter o código de incorporação assíncrono.",
      ],
    ),
  );

  grid.appendChild(
    guideCard(
      "Reprodução automática inteligente",
      [
        "A reprodução automática sem som, com toque para ativar, é a opção mais segura dentro de um iframe.",
        "Os navegadores bloqueiam reprodução automática com som sem interação prévia.",
        "O overlay de reprodução automática orienta o usuário a ativar o som.",
      ],
    ),
  );

  grid.appendChild(
    guideCard(
      "CTA com atraso",
      [
        "Exiba a chamada para ação conforme o progresso assistido, não pelo tempo na página.",
        "Escolha um percentual assistido ou um momento do vídeo.",
        "O máximo assistido evita manipulação ao avançar o vídeo.",
      ],
    ),
  );

  grid.appendChild(
    guideCard(
      "Retomar reprodução",
      [
        "Quem retornar poderá continuar de onde parou.",
        "Escolha perguntar, sempre continuar ou sempre reiniciar em cada VSL.",
        "O progresso é salvo localmente e se adapta quando o armazenamento estiver bloqueado.",
      ],
    ),
  );

  grid.appendChild(
    guideCard(
      "Integração com o Full Funnel",
      [
        "Conecte sua localização do Full Funnel em Integrações.",
        "Cada administrador informa sua própria credencial, sem conta compartilhada.",
        "As chaves são criptografadas e não voltam a ser exibidas após a conexão.",
      ],
    ),
  );

  grid.appendChild(
    guideCard(
      "Incorporação e limites do iframe",
      [
        "As incorporações funcionam dentro de um iframe do Full Funnel.",
        "Tela cheia, área de transferência, download e acesso à janela principal podem ser restritos.",
        "O player se adapta às capacidades disponíveis.",
      ],
    ),
  );

  append(wrapper, grid);

  // Footer note
  const note = el("div", "fva-info-banner");
  const head = el("div", "fva-support-note-head");
  head.appendChild(icon(ICONS.help, "fva-kpi-icon"));
  head.appendChild(el("strong", null, " Precisa de mais ajuda?"));
  note.appendChild(head);
  note.appendChild(
    document.createTextNode(
      " Esta é a suíte operacional do MVP. Solicitações e relatos de erro são encaminhados à equipe FullVSL.",
    ),
  );
  append(wrapper, note);

  return wrapper;
}

function guideCard(title: string, steps: string[]): HTMLElement {
  const card = el("div", "fva-card fva-card-pad");
  append(card, el("h3", "fva-publish-section-title", title));
  const list = el("ul", "fva-support-list");
  for (const step of steps) {
    const li = el("li", "fva-support-list-item");
    li.appendChild(icon(ICONS.checkCircle, "fva-support-check"));
    li.appendChild(document.createTextNode(" " + step));
    list.appendChild(li);
  }
  append(card, list);
  return card;
}
